import { Admin, defaultLightTheme, Login, Resource } from 'react-admin'

import { authProvider } from './authProvider'
import { Layout } from './components/molecules/Layout'
import { HistoricalInspectionList } from './components/screens/HistoricalInspectionList'
import { HistoricalInspectionShow } from './components/screens/HistoricalInspectionShow'
import { InspectionList } from './components/screens/InspectionList'
import { InspectionShow } from './components/screens/InspectionShow'
import { dataProvider } from './dataProvider'
import { i18nProvider } from './i18n'
// Ensure we're using light theme

export const App = () => (
  <Admin
    layout={Layout}
    authProvider={authProvider}
    dataProvider={dataProvider}
    i18nProvider={i18nProvider}
    theme={defaultLightTheme}
    requireAuth
    loginPage={Login}
  >
    {/*
      Registration order decides the landing screen: React Admin routes / to the
      first resource the user can list. Historical inspections stays first.
    */}
    <Resource name="historical_inspections" list={HistoricalInspectionList} show={HistoricalInspectionShow} />
    <Resource name="inspections" list={InspectionList} show={InspectionShow} />
  </Admin>
)
